import { createRouter, createWebHistory } from 'vue-router';
import { nextTick } from 'vue';

// Lazy-load views for code splitting
const DashboardView = () => import('../views/DashboardView.vue');
const InvestigationListView = () => import('../views/InvestigationListView.vue');
const InvestigationDetailView = () => import('../views/InvestigationDetailView.vue');
const NotFoundView = () => import('../views/NotFoundView.vue');

const routes = [
  {
    path: '/',
    name: 'dashboard-root',
    component: DashboardView,
    meta: {
      title: 'Dashboard - Aura Investigations'
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    meta: {
      title: 'Dashboard - Aura Investigations'
    }
  },
  {
    path: '/investigations',
    name: 'investigations',
    component: InvestigationListView,
    meta: {
      title: 'Investigations - Aura Investigations'
    }
  },
  {
    path: '/investigations/:id',
    name: 'investigation-detail',
    component: InvestigationDetailView,
    meta: {
      title: 'Investigation Detail - Aura Investigations'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFoundView,
    meta: {
      title: '404 Not Found - Aura Investigations'
    }
  }
];

const router = createRouter({
  history: createWebHistory('/dashboard/vue/'),
  routes,

  // Scroll behavior for navigation
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved position (from browser back/forward), restore it
    if (savedPosition) {
      return savedPosition;
    }
    // Otherwise, scroll to top
    return { top: 0 };
  }
});

// Navigation guard for accessibility (focus management and document title)
router.beforeEach((to, from, next) => {
  // Update document title
  document.title = to.meta.title || 'Aura Investigations';

  // Continue navigation
  next();

  // After navigation completes, move focus to main heading for screen reader users
  nextTick(() => {
    const mainHeading = document.querySelector('h1');
    if (mainHeading) {
      mainHeading.focus();
      // Ensure the h1 is focusable for programmatic focus
      if (!mainHeading.hasAttribute('tabindex')) {
        mainHeading.setAttribute('tabindex', '-1');
      }
    }
  });
});

export default router;
